const languages = [
  {
    id: 'en',
    label: 'English',
  },
  {
    id: 'pt',
    label: 'Português',
  },
  {
    id: 'ko',
    label: '한국어',
  },
  {
    id: 'es',
    label: 'Español',
  },
  {
    id: 'ja',
    label: '日本語',
  },
  {
    id: 'fr',
    label: 'Français',
  },
  {
    id: 'it',
    label: 'Italiano',
  },
  {
    id: 'de',
    label: 'Deutsch',
  },
  {
    id: 'ru',
    label: 'Русский',
  },
  {
    id: 'ar',
    label: 'العربية',
  },
  {
    id: 'zhhant',
    label: '中文',
  },
  {
    id: 'zhhans',
    label: '普通话（简体)',
  },
]
export default languages
